import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// MAIN COMPONENT
const IMVLabel = ({ value, placeholder }) =>
  value ? (
    <span
      className={clsx(
        ['Fair', 'Good', 'Great'].includes(value) && 'text-success',
        ['High'].includes(value) && 'text-warning',
        ['Overpriced'].includes(value) && 'text-danger'
      )}
    >
      {value}
    </span>
  ) : (
    placeholder
  );

// EXPORT
export default IMVLabel;
